import BarChart from './BarChart';

export default BarChart;


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/performancePerTurn/components/barChart/index.js